// Shared component styles. Preserve selector order, style values, and caller overrides.
import { createToolbarTextFieldSx } from "./toolbarControlStyles";
import { pillButtonInteractiveSx, pillButtonFilledSx, toolbarPillButtonSx } from "./buttonStyles";

export const BLUE = "#3451F4";
export const PILL_BG = "#E0F2FE";
export const UNDERLINE = "#3B82F6";
export const BASELINE = "#E5E7EB";
export const listHeaderStyles = {
  root: () => ({
    paddingTop: "12px",
    paddingBottom: "6px",
    display: "flex",
    flexDirection: "column",
    "& > [id]": {
      order: 3
    }
  }),
  headingRow: () => ({
    display: "flex",
    flexDirection: {
      xs: "column",
      lg: "row"
    },
    justifyContent: "space-between",
    alignItems: {
      xs: "stretch",
      lg: "center"
    },
    gap: 2,
    minWidth: 0
  }),
  title: () => ({
    paddingLeft: 0,
    pb: 0.25,
    pt: 0,
    width: {
      xs: "100%",
      lg: "auto"
    },
    flex: {
      lg: "0 0 auto"
    },
    minWidth: 0,
    "& .MuiCardHeader-content": {
      minWidth: 0
    },
    "& .MuiTypography-root": {
      overflowWrap: "anywhere"
    }
  }),
  controls: () => ({
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row"
    },
    alignItems: {
      xs: "stretch",
      md: "center"
    },
    gap: 2,
    width: {
      xs: "100%",
      lg: "auto"
    },
    minWidth: 0
  }),
  search: () => createToolbarTextFieldSx({
    widthSx: {
      width: {
        xs: "100%",
        md: 320,
        xl: 448
      },
      maxWidth: "100%",
      minWidth: 0
    }
  }),
  actions: () => ({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: {
      xs: "stretch",
      md: "flex-end"
    },
    gap: 1.5,
    width: {
      xs: "100%",
      md: "auto"
    },
    "& > .MuiButton-root": {
      width: {
        xs: "100%",
        sm: "auto"
      }
    }
  }),
  actionButton: ({
    action
  }) => [pillButtonInteractiveSx, {
    textTransform: "none",
    borderRadius: 999,
    whiteSpace: "nowrap",
    ...(action.variant === "contained" ? {
      ...pillButtonFilledSx
    } : {})
  }, action.variant === "contained" ? toolbarPillButtonSx : {}, action.sx || {}],
  customTabRow: () => ({
    order: 2
  }),
  tabRow: () => ({
    position: "relative",
    mt: 2,
    pb: 0,
    mb: 0,
    order: 2
  }),
  tabContent: () => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    position: "relative",
    pb: 0.9 // space for underline
  }),
  tabLabel: () => ({
    fontSize: 13,
    fontWeight: 700,
    color: BLUE,
    lineHeight: 1
  }),
  tabCount: () => ({
    px: 1,
    py: "2px",
    borderRadius: 999,
    backgroundColor: PILL_BG,
    color: BLUE,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.4
  }),
  tabIndicator: () => ({
    position: "absolute",
    left: 0,
    bottom: 0,
    height: "3px",
    width: "100%",
    backgroundColor: UNDERLINE,
    marginBottom: "-1px",
    zIndex: 1
  }),
  baseline: () => ({
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: "1px",
    backgroundColor: BASELINE
  })
};
